import React from 'react'
import ResetPassword from '../components/ResetPassword/ResetPassword'

export default function ForgotPassword() {
  return (
   <ResetPassword />
  )
}
